
import PropTypes from 'prop-types';

function AddressCard(props) {
  return (
    <div className={"card bg-white addresses-item mb-4 " + (this.props.boxClass)}>
        <div className="gold-members p-4">
           <div className="media" >
              <div className="mr-3"><i className={"icofont icofont-"+props.icoIcon + ' ' + props.iconclassName} /></div>
              <div className="media-body">
                 <h6 className="mb-1 text-secondary">{props.title}</h6>
                 <p className="text-black">{props.address}
                 </p>
                 <p className="mb-0 text-black font-weight-bold">
                    <a className="text-primary mr-3" href="#" onClick={props.onEditClick}><i className="icofont-ui-edit" /> EDIT</a>
                    <a className="text-danger" href="#" onClick={props.onDeleteClick}><i className="icofont-ui-delete" /> DELETE</a></p>
              </div>
           </div >
        </div>
    </div>
  );
}

AddressCard.propTypes = {
  title: PropTypes.string.isRequired,
  icoIcon: PropTypes.string.isRequired,
  iconclassName: PropTypes.string,
  address: PropTypes.string,
  onEditClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired
};

export default AddressCard;


export function DisplayAddressCard(props) {

  const addressLine = () => {
    if (props.address.address && props.address.city) {
      return props.address.address + ', ' + props.address.city
    }
    return ''
  }

  return (
    <div className={"card bg-white addresses-item mb-4 " + (props.boxClass)}>
      <div className="gold-members p-3">
        <div className="media" >
          <div className="mr-3"><i className={"icofont icofont-"+props.icoIcon + ' ' + props.iconclassName} /></div>
          <div className="media-body">
            <h6 className="mb-1 text-secondary">{props.title}  </h6>
            <div className="text-black">{props.address.name}</div>
            <div className="text-black">{props.address.phone}</div>
            <p className="text-black">{addressLine() }</p>
            {props.address.instructions &&
              <p className="text-black">{props.address.instructions }</p>
            }
          </div>
        </div >
      </div>
    </div>
  );
}